import PreviewTable from 'app/features/questionnaires/components/PreviewTable';
import { selectPrepareQuestionnaire } from 'app/features/questionnaires/create/PrepareQuestionnaire/slice';
import { useFields } from 'app/features/questionnaires/create/PrepareQuestionnaire/useFields';
import { countriesLookUp } from 'countries';

import { useSelector } from 'react-redux';
import { statesLookup } from 'states';

export interface IPreviewSummaryProps {}

export default function PreviewSummary(props: IPreviewSummaryProps) {
  const prepareQuestionnaire = useSelector(selectPrepareQuestionnaire);
  const { fields } = useFields();
  return (
    <PreviewTable
      fields={fields}
      sectionName="Situation Analysis"
      fieldsState={{
        values: prepareQuestionnaire,
      }}
    />
  );
}
